/**
 * Shared form layout and style tokens.
 *
 * Centralizes spacing, color, typography, and responsive presets used by the
 * canonical form renderer. Form headings must remain visually aligned with
 * their semantic document hierarchy.
 */
export const formTokens = {
  spacing: {
    sectionGap: 3,
    sectionInnerGap: 2.5,
    actionBarPaddingY: 1.5,
    actionBarGap: 1,
  },
  colors: {
    actionBarBackground: 'background.paper',
    actionBarBorder: 'divider',
  },
  typography: {
    title: 'h3',
    description: 'body2',
    sectionTitle: 'h4',
    sectionDescription: 'body2',
  },
  actionBar: {
    /**
     * Sticky within the form's scroll context: short forms remain naturally at
     * the footer, while long forms keep the primary action reachable without a
     * floating overlay or duplicate save button.
     */
    position: 'sticky',
    bottom: 0,
    zIndex: 5,
  },
} as const;
